/**
 * Mobile platform breakpoint condition
 * @param {boolean} sm Include large phones / small tablets?
 * @returns boolean
 */
const isMobile = (sm = true) => {
    if(window.breakpoints){
        if(sm){
            return window.breakpoints.smAndDown;
        } else {
            return window.breakpoints.xs;
        }
    }

    return false;
}

export default isMobile;